import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import { Button, CircularProgress, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import { uploadDocuments } from "_controllers/officer";
import axios from "axios";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import dotenv from "dotenv";
import { useHistory } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import authAxios from "setups/axios";

dotenv.config();

const Main = () => {
    const navigate = useHistory()

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [image, setImage] = useState('')

    useEffect(async () => {
        const requests = await uploadDocuments();
        setData(requests?.docs);
        setLoading(true);
    }, [message])

    const handleImage = async (category) => {
        console.log("object", category);
        const formData = new FormData();
        formData.append("file", image);
        formData.append("fileName", image.name);
        formData.append("type", category)
        const token = localStorage.getItem("token");
        const config = {
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }
        const url = process.env.REACT_APP_REQUEST_ENDPOINT
        await axios.post(
            `${url}/api/v1/document/upload`,
            formData, config
        ).then((res) => {
            setImage('')
            setMessage(res?.data?.message)
            toastMessage(res?.data?.message, "success");
        }).catch((err) => {
            setImage('')
            setMessage(err?.message)
            toastMessage("Select File First.", "error");
        });
    };

    const saveImg = (e) => {
        setImage(e.target.files[0]);
    };

    const handleDelete = async (id) => {
        const response = await authAxios()({
            url: `/api/v1/document/${id}`,
            method: "DELETE",
        });
        toastMessage(response.data.message, "success")
        setMessage(response?.data.message);
    }

    return (
        <>
            <Box
                style={{
                    padding: "0px 20px",
                    border: "1px solid #eaeaea",
                    borderRadius: "10px",
                    boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                    // marginTop: "10px",
                    marginRight: "20px",
                    display: 'flex',
                    justifyContent: "space-between"
                }}
            >
                <Grid>
                    <p style={{ fontWeight: "bolder", fontSize: '1.25rem' }}>Upload Documents</p>
                </Grid>
                <Button variant="contained" sx={{ height: '50%', margin: '14px 25px 0px 0px' }} onClick={() => navigate.push('/add-documents')}>ADD Document</Button>
            </Box>

            <Box style={{
                marginRight: "20px",
            }}>
                {loading ? (
                    <>
                        <TableContainer component={Paper} sx={{ mt: 3 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Document Type</TableCell>
                                        <TableCell align="left" sx={{ fontWeight: 'bolder' }}>Description</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Uploaded Doc</TableCell>
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Last Upload On</TableCell>
                                        {/* <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Upload</TableCell> */}
                                        <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {data && data?.length > 0
                                        ? data?.map((d) => (
                                            <TableRow key={d._id}>
                                                <TableCell align="left">{d?.documentCategory}</TableCell>
                                                <TableCell align="left">{d?.description}</TableCell>
                                                <TableCell align="center"><a href={d?.url} target="_blank"><PictureAsPdfIcon color="primary" /></a></TableCell>
                                                <TableCell align="center">{d?.dateUploaded.slice(0, 10)}</TableCell>
                                                {/* <TableCell align="right">
                                                    <input type="file" onChange={saveImg} />
                                                </TableCell> */}
                                                <TableCell align="center" style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                    {/* <Button onClick={() => handleImage(d?.documentCategory)} variant='contained'>Upload</Button> */}
                                                    <EditIcon sx={{ border: '1px solid darkgrey', fontSize: '40px', borderRadius: '3px', cursor: 'pointer', color: "green" }} onClick={(() => navigate.push(`/upload-documents/edit/${d._id}`))} />
                                                    <DeleteIcon sx={{ border: '1px solid darkgrey', fontSize: '40px', borderRadius: '3px', cursor: 'pointer', color: 'red' }} onClick={() => handleDelete(d._id)} />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                        :
                                        <Box sx={{ textAlign: 'left', pt: 1 }}>
                                            <Typography variant="h6" sx={{ p: 1 }}>No Update Request Available.</Typography>
                                        </Box>}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>)
                    : (
                        <CircularProgress />
                    )}
            </Box>
        </>
    );
};

const Upload = () => {
    return (
        <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
            <DashGridL2 Top={TopBar} Main={Main} />
            <Toaster />
        </AccessController>
    );
};

export default Upload;
